// extracted by mini-css-extract-plugin
export default {"backToAccount":"NewPiece_backToAccount__yu-iQ","textEditor":"NewPiece_textEditor__VxF+p"};